import history from 'app/history';
import Layout from 'components/Layout';
import { ConnectedRouter } from 'connected-react-router';
import routes from 'pages/routes';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import Modals from './components/Modals';
import Notification from './components/Notification';
import { configureStore } from './store';

export default () => {
  const store = configureStore();

  ReactDOM.render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <Layout>
          <Switch>
            {routes.map((route, idx) => {
              const { Component, exact, path } = route;

              return (
                <Route
                  key={idx}
                  exact={exact}
                  path={path}
                  render={() => <Component />}
                />
              );
            })}
          </Switch>

          <Notification />
        </Layout>

        <Modals />
      </ConnectedRouter>
    </Provider>,
    document.getElementById('application'),
  );
};
